import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { Eucalyptus } from './botanical/Eucalyptus';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9g9ftWJsteQG1r7DZ97kAX/portada_2_hogar_natural.png';
export function NewMidCTA() {
  return <Section className="bg-forest-deep text-white py-20 relative overflow-hidden" data-id="element-165">
      <Eucalyptus className="absolute -top-10 -right-10 w-72 h-72 text-moss opacity-20 blur-sm rotate-45 pointer-events-none" aria-hidden="true" data-id="element-166" />
      <Eucalyptus className="absolute -bottom-10 -left-10 w-64 h-64 text-moss opacity-15 blur-sm -rotate-45 pointer-events-none" aria-hidden="true" data-id="element-167" />

      <div className="max-w-5xl mx-auto relative z-10 grid md:grid-cols-2 gap-10 items-center" data-id="element-168">
        <div className="relative flex justify-center" data-id="element-169">
          <div aria-hidden="true" className="absolute inset-0 bg-honey/25 blur-3xl rounded-full scale-90" data-id="element-170" />
          <img src={PRODUCT_IMAGE} alt="Hogar Natural en Casa — acceso inmediato" className="relative w-full max-w-[360px] h-auto rounded-2xl shadow-2xl border border-honey/30" data-id="element-171" />
        </div>

        <div className="text-center md:text-left" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream-warm mb-5" data-id="element-173">
            Todo esto, listo para usar esta misma noche
          </h2>
          <p className="text-lg text-cream-warm/85 mb-8 leading-relaxed" data-id="element-174">
            5 tomos + 5 bonos en formato digital, con acceso inmediato desde tu
            teléfono o computadora. Tuyo para siempre.
          </p>
          <Button variant="primary" size="xl" href={CHECKOUT_URLS.superPack} className="bg-honey hover:bg-honey-dark text-forest-deep font-bold w-full sm:w-auto px-8 py-5 text-base sm:text-lg" data-id="element-175">
            👉 QUIERO EL SISTEMA COMPLETO — $27.999
          </Button>
        </div>
      </div>
    </Section>;
}